import { ImageService } from './../../_services/image.service';

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-image',
  templateUrl: './test-image.component.html',
  styleUrls: ['./test-image.component.css']
})
export class TestImageComponent implements OnInit {
 imageSource:any=undefined
 loading=false
  constructor(private imageService :ImageService) { }

  ngOnInit(): void {
  }
   testImage(){
     this.imageSource=undefined
     this.loading=true
     this.imageService.testImage().subscribe(
       iValue =>{
         this.loading=false
        this.imageSource =  "<img src=data:image/png;base64,"+iValue+">"
       }
     )

   }
}
